import React, { FC } from "react";
import { NavLink } from "react-router-dom";

import { IconButton, IconButtonProps } from "@mui/material";

import { ViewIcon } from "../../../components/icons";
import { ActivityLog } from "../../../store/pomeriumApi";

type Props = {
  activityLog: ActivityLog;
} & IconButtonProps;

const DiffButton: FC<Props> = ({ activityLog, ...props }) => {
  return (
    <IconButton
      component={NavLink}
      sx={{ mr: 2 }}
      to={{
        pathname: [
          "/app/reports/deployments/diff",
          activityLog.entity?.type,
          activityLog.entity?.id,
        ].join("/"),
        search:
          "?" +
          new URLSearchParams({
            to: activityLog.id,
          }).toString(),
      }}
      size="small"
      {...props}
    >
      <ViewIcon />
    </IconButton>
  );
};

export default DiffButton;
